import React from 'react'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'
import { DropdownMenu, DropdownMenuItems } from '@nominex/dex-uikit'
import StyledNetworkItem from '../styles'

interface TelegramLinkProps {
  items?: DropdownMenuItems[]
}
// TODO: use cupertino pane on mobile devices
const Telegram: React.FC<TelegramLinkProps> = ({ items }) => (
  <DropdownMenu items={items}>
    <StyledNetworkItem className="text-brand-telegram">
      <SlIcon library="social" name="telegram" />
    </StyledNetworkItem>
  </DropdownMenu>
)

export default Telegram
